class PagesNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.intersectionObserverCallback = this.intersectionObserverCallback.bind(
      this,
    )

    if (this.isIntersectionObserverSupported) {
      this.observer.observe(this.stickyElement)
    }
  }

  /**
   * Calls the initialise function when the custom element is intersecting (visible in the viewport)
   */
  intersectionObserverCallback (entries) {
    const entry = entries?.[0]
    if (!entry) return
    this.stickyElement.classList.toggle(
      'util-StickySection_Stuck',
      entry.intersectionRatio < 1,
    )
  }

  /**
   * @returns {IntersectionObserver} an observer that specifies when an element is intersecting (visible in viewport)
   */
  get observer () {
    // eslint-disable-next-line compat/compat
    return new IntersectionObserver(this.intersectionObserverCallback, {
      threshold: [0, 1],
    })
  }

  /**
   * @returns {boolean} Whether or not IntersectionObserver is supported by the browser
   */
  get isIntersectionObserverSupported () {
    return `IntersectionObserver` in window
  }

  /**
   * @returns {HTMLElement} Is this element sticky, or one of its parents?
   */
  get stickyElement () {
    const thisIsSticky = this.classList.contains('util-StickySection')
    return thisIsSticky ? this : this.closest('.util-StickySection')
  }
}

if (!customElements.get('pages-navigation')) {
  customElements.define('pages-navigation', PagesNavigation)
}
